module.exports = __webpack_public_path__ + "img/Default-J-10.3b623098.svg";